import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, signal } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { BaseDetailComponent } from '../../../../common/base-detail.component';
import { Address } from '../../../../generated/generated-types';
import { BlockableDiv } from '../../../../shared/controls/blockable-div/blockable-div.component';
import { BankAccountLinkListWidgetComponent } from '../bank-account-link-list-widget/bank-account-link-list-widget.component';

@Component({
  selector: 'app-formly-bank-account-link-list',
  templateUrl: './formly-bank-account-link-list.component.html',
  styleUrls: ['./formly-bank-account-link-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    ButtonModule,
    BlockableDiv,
    TooltipModule,
    TranslatePipe,
    BankAccountLinkListWidgetComponent
  ]
})
export class FormlyBankAccountLinkListComponent extends FieldType<FieldTypeConfig> implements OnInit {

  addressId = signal<string>(null);

  isSaving = signal<boolean>(false);

  constructor() { super(); }

  ngOnInit(): void {
    if (this.model) {
      this.addressId.set(this.model[this.key as string]); // The key is comming from the formly field definition[fallbacks]
    }

    this.formControl.valueChanges.subscribe((model: string) => {
      let addressId = model;
      if (this.addressId() != addressId) {
        this.addressId.set(addressId);
      }
    })
  }

  checkIfCanSave() {
    let component = this.options.formState.detailComponent as BaseDetailComponent<Address>;
    return component.detailForm.invalid;
  }

  async saveToUnlockEditMode() {

    //Other options would be to use the service, but special overwrite in the component wont be used then

    let component = this.options.formState.detailComponent as BaseDetailComponent<Address>;
    if (!component) {
      console.error("No detail component found to save");
      return;
    }

    this.isSaving.set(true);

    await component.save();

    this.isSaving.set(false);
  }

}
